export const RoutesEnum = {
  ADMIN: '/admin',
  ADMIN_LOGIN: '/admin-login',
  CONFLICT_409: '/409',
  ERROR: '/error',
  INACTIVE: '/inactive',
  LOGIN: '/login/:token',
  QUIZ: '/quiz',
  ROOT: '/',
  SERVICE_UNAVAILABLE: '/503',
  WELCOME: '/',
} as const;

export type RoutesEnum = (typeof RoutesEnum)[keyof typeof RoutesEnum];
